
define('text!templates/pages/trade/offer/repeat/sidebar-row.ejs',[],function () { return '<td class="trade-repeat-trade-name"><%= date(tradeDate) %> <%= tradeCode %></td>\n';});

